<script setup>
import {computed, defineModel} from 'vue'
import BaseSubIcon from "@/components/UI/svg/subscriptions/BaseSubIcon.vue";
import StandardSubIcon from "@/components/UI/svg/subscriptions/StandardSubIcon.vue";
import PremiumSubIcon from "@/components/UI/svg/subscriptions/PremiumSubIcon.vue";

const sub = defineModel('sub')
const duration = defineModel('duration')
const price = defineModel('price')
const currentStep = defineModel('currentStep')
const stepsQuantity = defineModel('stepsQuantity')
const switchStatus = defineModel('switchStatus')

const transactions = defineModel('transactions')


const nameToSvg = [
    {
        name: 'Базовый',
        svg: BaseSubIcon,
    },
    {
        name: 'Стандартный',
        svg: StandardSubIcon,
    },
    {
        name: 'Премиум',
        svg: PremiumSubIcon,
    },
]


function lengthToMonthName(duration) {
    if (duration === 1) return "месяц"
    if (duration >= 2 && duration <= 4) return "месяца"
    if (duration >= 5) return "месяцев"
    return "месяц"
}

function findSvgByName(name) {
    return nameToSvg.find((element) => element.name === name)
}

const formattedPrice = computed(() => {
    return price.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

const formattedTransactions = computed(() => {
    return sub.value?.transactions_rate_per_month.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

</script>

<template>
    <div class="w-full  h-auto lg:h-[340px] flex flex-col p-4 lg:p-[25px] bg-white border border-[#e1e1e1] rounded-[16px]">
        <div class="font-bold text-[16px] lg:text-[18px] mb-4 lg:mb-[32px]">Ваш заказ</div>
        <div class="bg-[#edf2f8] w-full rounded-[12px] p-3 lg:p-[16px]" v-if="switchStatus === 'subs'">
            <div class="flex gap-2 items-center">
                <div class="size-8 lg:size-10 bg-blue-100 flex items-center justify-center rounded-[12px] flex-shrink-0">
                    <component :is="findSvgByName(sub?.name)?.svg" class="size-4 lg:size-5 stroke-black" />
                </div>
                <div class="text-base lg:text-lg font-bold">{{sub?.name}} </div>
            </div>
            <div class="text-[#555555] text-sm lg:text-base">{{ formattedTransactions }} транзакций/мес.</div>
            <div class="text-[#555555] text-sm lg:text-base">{{ duration?.month_count }} {{ lengthToMonthName(duration?.month_count) }}</div>
        </div>
        <div class="bg-[#edf2f8] w-full rounded-[12px] p-3 lg:p-[16px]" v-if="switchStatus === 'transactions'">
            <div class="text-base lg:text-lg font-bold">Дополнительные транзакции</div>
            <div class="text-[#555555] text-sm lg:text-base">{{ transactions }} транзакций</div>
            <div class="text-[#555555] text-sm lg:text-base">Единоразовая покупка</div>
        </div>
        <div class="mb-3 lg:mb-[16px] mt-3 lg:mt-[16px] w-full border-t border-b border-[#e1e1e1] flex flex-col justify-center">
            <div class="flex justify-between items-center py-3 lg:pt-4 lg:pb-4">
                <div class="font-bold text-[14px] lg:text-[16px]">Итого к оплате</div>
                <div class="font-bold text-[14px] lg:text-[16px] text-blue-500">{{ formattedPrice }} ₽</div>
            </div>
        </div>
        <div>
            <div class="text-sm lg:text-base">Шаг {{ currentStep.index }} из {{ stepsQuantity }}</div>
            <div
                class="bg-gray-100 rounded-full h-2 relative overflow-hidden mt-2">
                <div class="absolute top-0 bottom-0 w-full rounded-md bg-blue-500" :style="'transform: translateX(-' + (100 - currentStep.index / stepsQuantity * 100) + '%)'"></div>
            </div>
        </div>

    </div>
</template>

<style scoped>

</style>